import { render } from "./SettingsEmailsTemplatesDeleteModal.vue?vue&type=template&id=eabe54e4"
import script from "./SettingsEmailsTemplatesDeleteModal.vue?vue&type=script&lang=js"
export * from "./SettingsEmailsTemplatesDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__